import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import { BaseView } from '@bingads-webui/base-view';
import { SubAccountHotelGroupEditPanel } from '@bingads-webui-campaign-react/subaccount-hotelgroup-selector';

export class SubAccountHotelGroupEditPanelView extends BaseView {
  initialize(options) {
    this.options = options;
    this.rootId = this.options.rootId || 'subaccount-hotelgroup-edit-panel-root';
  }

  render() {
    const props = {
      hotelGroups: this.options.hotelGroups || [],
      isSubAccountSelected: this.options.isSubAccountSelected || true,
      preSelectedKey: this.options.preSelectedKey,
      onSubAccountClick: this.options.onSubAccountClick || _.noop,
      onHotelGroupClick: this.options.onHotelGroupClick || _.noop,
      onCreateLinkClick: this.options.onCreateLinkClick || _.noop,
      onSearch: this.options.onSearch || _.noop,
      onSearchClear: this.options.onSearchClear || _.noop,
      onRenameSubaccountSubmit: this.options.onRenameSubaccountSubmit || _.noop,
      onDeleteSubaccountSubmit: this.options.onDeleteSubaccountSubmit || _.noop,
      onRenameHotelGroupSubmit: this.options.onRenameHotelGroupSubmit || _.noop,
      onDeleteHotelGroupSubmit: this.options.onDeleteHotelGroupSubmit || _.noop,
      i18n: this.options.i18n,
    };

    return React.createElement(SubAccountHotelGroupEditPanel, props, null);
  }

  remove() {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.rootId));

    return super.remove();
  }
}
